import React from 'react';
import { getAvatarGradient, getInitials } from '../../../utils/nameColors';

const CharacterPage = React.forwardRef(({ characters, pageNumber }, ref) => {
  return (
    <div ref={ref} className="book-page">
      <div className="book-page-inner bg-white px-4 sm:px-6 py-4 overflow-hidden">
        {/* Header */}
        <div className="mb-2.5">
          <h2
            className="text-sm sm:text-base font-bold text-gray-900 uppercase tracking-tight"
            style={{ fontFamily: "'Sora', sans-serif" }}
          >
            Cast of Characters
          </h2>
          <div className="w-5 h-0.5 bg-rose-700 rounded-full mt-1 mb-0.5" />
          <p
            className="text-[9px] text-gray-500"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            The people behind the messages
          </p>
        </div>

        {/* Character Cards */}
        <div className="space-y-2 flex-1 overflow-hidden">
          {characters.map((char, idx) => (
            <div
              key={idx}
              className="rounded border-l-[2.5px] border-rose-600 bg-white shadow-sm px-2.5 py-2"
              style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}
            >
              <div className="flex items-center gap-1.5 mb-1.5">
                <div
                  className={`w-6 h-6 rounded-full bg-gradient-to-br ${getAvatarGradient(char.name)} flex items-center justify-center text-white text-[8px] font-bold shrink-0`}
                >
                  {getInitials(char.name)}
                </div>
                <h3
                  className="text-xs font-bold text-rose-700"
                  style={{ fontFamily: "'Sora', sans-serif" }}
                >
                  {char.name}
                </h3>
              </div>

              <p
                className="text-[9px] sm:text-[10px] text-gray-600 leading-snug mb-1.5"
                style={{ fontFamily: "'DM Sans', sans-serif" }}
              >
                {char.bio}
              </p>

              {/* Traits */}
              {char.traits && char.traits.length > 0 && (
                <div className="flex flex-wrap gap-0.5 mb-1.5">
                  {char.traits.map((trait, i) => {
                    const colors = [
                      'bg-amber-500',
                      'bg-rose-600',
                      'bg-emerald-600',
                      'bg-gray-700',
                    ];
                    return (
                      <span
                        key={i}
                        className={`text-[6px] sm:text-[7px] font-semibold text-white px-1.5 py-px rounded uppercase tracking-wider ${colors[i % colors.length]}`}
                      >
                        {trait}
                      </span>
                    );
                  })}
                </div>
              )}

              {/* Signature Quote */}
              {char.signature_quote && (
                <p
                  className="text-[8px] sm:text-[9px] italic text-gray-500 pl-2 border-l border-amber-400 leading-snug"
                  style={{ fontFamily: "'DM Sans', sans-serif" }}
                >
                  &ldquo;{char.signature_quote}&rdquo;
                </p>
              )}

              <p
                className="text-[7px] text-gray-400 mt-1 uppercase tracking-wider"
                style={{ fontFamily: "'Space Mono', monospace" }}
              >
                {char.story_count} stories
              </p>
            </div>
          ))}
        </div>

        {pageNumber !== undefined && (
          <div className="book-page-number">{pageNumber}</div>
        )}
      </div>
    </div>
  );
});

CharacterPage.displayName = 'CharacterPage';
export default CharacterPage;
